import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Chip, Stack } from '@mui/material';
import { FinanceDateType } from '@trnsact/trnsact-shared-types';
import { FinanceFilters, FinanceFilterType } from '../types';
import { DATE_RANGE_OPTIONS } from 'modules/finance/pipelineAndWon/constants';
import { FinanceDateRange } from 'modules/finance/pipelineAndWon/types';
import { DateTypeToggle } from 'modules/finance/ui/components/DateTypeToggle';
import { CustomDateRangeInputs } from 'modules/finance/ui/components/CustomDateRangeInputs';

export const FinanceDealDateRange = () => {
  const { control, setValue } = useFormContext<FinanceFilters>();
  const current = useWatch({ control, name: FinanceFilterType.DEAL_DATE });
  const dateType = useWatch({ control, name: FinanceFilterType.DATE_TYPE });
  const customDateRange = useWatch({ control, name: 'customDateRange' });

  return (
    <Stack spacing={1.5}>
      <DateTypeToggle
        value={dateType ?? FinanceDateType.CreatedOn}
        onChange={v => setValue(FinanceFilterType.DATE_TYPE, v)}
      />

      <Stack direction="row" gap="0.5rem" flexWrap="wrap" alignItems="center">
        {DATE_RANGE_OPTIONS.map(opt => (
          <Chip
            key={opt.value}
            label={opt.label}
            size="small"
            onClick={() => setValue(FinanceFilterType.DEAL_DATE, opt.value as FinanceDateRange)}
            variant={current === opt.value ? 'filled' : 'outlined'}
            color={current === opt.value ? 'primary' : 'default'}
            sx={{ fontSize: 11, fontWeight: 500, height: 26, cursor: 'pointer' }}
          />
        ))}
        {current === 'custom' && (
          <CustomDateRangeInputs value={customDateRange ?? null} onChange={v => setValue('customDateRange', v)} />
        )}
      </Stack>
    </Stack>
  );
};
